import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TableContainer } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddFlavor from "../../Modals/addflavor";

const ManageFlavor = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");


  const [flavors, setFlavors] = useState([
    { id: 1, name: "Strawberry", color: '#FF9EB1', status: true },
    { id: 2, name: "Mango", color: '#FFA030', status: true },
    { id: 3, name: "Chocolate", color: '#6E3610', status: false },
    { id: 4, name: "Blueberry", color: '#7289C5', status: true },
  ]);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="main_title">
        <h1>Manage Flavor</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Flavor
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Flavors..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Flavor
            </Button>
          </div>
        </div>

        {/* Flavor Table */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Flavor Name</TableCell>
                <TableCell>Flavor Color Code</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {flavors
                .filter((f) =>
                  f.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((flavor, index) => (
                  <TableRow key={flavor.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{flavor.name}</TableCell>
                    <TableCell>
                      <span className="color_code">
                        <span className="color_box" style={{ backgroundColor: flavor.color }}></span> {flavor.color}
                      </span>
                    </TableCell>
                    <TableCell>
                      <SwitchToggle />
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal(true)}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <AddFlavor
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageFlavor;
